import React from 'react'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const LoadingIndicator = () => (
  <div className="absolute w-full h-full flex justify-center items-center align-center z-50">
    <FontAwesomeIcon icon={faSpinner} size="5x" spin className="text-orange-600" />
  </div>
)
